export default __webpack_public_path__ + "static/media/MathWallet.19212234.svg";